export default function CTAFinal() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Family together feeling safe and connected"
          className="w-full h-full object-cover"
          src="https://readdy.ai/api/search-image?query=Happy%20multi-generational%20family%20gathering%20together%20outdoors%2C%20warm%20sunset%20light%2C%20elderly%20parent%20surrounded%20by%20loving%20family%2C%20navy%20and%20green%20color%20tones%2C%20lifestyle%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=cta-1&orientation=landscape"
        />
        <div className="absolute inset-0 bg-primary-600/85"></div>
      </div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 rounded-full px-3 py-1.5 mb-6">
          <i className="ri-heart-fill text-accent-400 text-xs"></i>
          <span className="text-xs font-semibold text-white uppercase tracking-wider">Your Care Bridge Starts Here</span>
        </div>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mb-5 leading-tight">
          Start building a safer care bridge around your loved one
        </h2>
        <p className="text-base md:text-lg text-white/95 max-w-xl mx-auto leading-relaxed mb-8">
          CareBridge helps families stay connected, organized, and ready to respond when elderly parents need support. You do not have to care alone.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://carebridge4elderly.base44.app" target="_blank" rel="nofollow noopener noreferrer"
            className="bg-secondary-500 text-white font-semibold px-8 py-4 rounded-full hover:bg-secondary-600 transition-all cursor-pointer text-sm whitespace-nowrap w-full sm:w-auto inline-block text-center"
          >
            Join the App
          </a>
          <a
            href="https://carebridge4elderly.base44.app" target="_blank" rel="nofollow noopener noreferrer"
            className="bg-white/10 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/20 transition-all cursor-pointer text-sm whitespace-nowrap border border-white/20 w-full sm:w-auto inline-block text-center"
          >
            Try the Free Demo
          </a>
        </div>
        <div className="mt-8 pt-6 border-t border-white/20">
          <p className="text-sm text-white/80 mb-3">Questions first? Talk to a real person.</p>
          <a
            href="mailto:family1st@carebridge.club"
            className="inline-flex items-center gap-3 bg-white text-primary-600 font-bold px-5 py-3 rounded-full hover:bg-background-100 transition-all cursor-pointer text-sm md:text-base whitespace-nowrap max-w-full"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-white flex-shrink-0">
              <i className="ri-mail-line text-sm"></i>
            </span>
            <span className="break-all">family1st@carebridge.club</span>
          </a>
        </div>
        <p className="text-sm text-white/85 mt-6">
          Includes built-in demos for Premium Monthly and Discharge Plan — with a 7-day free trial before billing starts.
        </p>
      </div>
    </section>
  );
}